import axios from '@axios'

export default {
  namespaced: true,
  state: {
    items: [],
  },
  getters: {},
  mutations: {
    ITEMS(state, value) {
      state.items = value
    },
  },
  actions: {
    fetchItems(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('/appel_a_textes', { params: queryParams })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchItem(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/item/${id}`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    addItem(ctx, itemData) {
      return new Promise((resolve, reject) => {
        axios({
          method: 'post',
          url: '/appel_a_textes',
          data: itemData,
          // eslint-disable-next-line no-unused-vars
          validateStatus: status => true,
        })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    deleteItem(ctx, id) {
      return new Promise((resolve, reject) => {
        axios
          .delete(`/appel_a_textes/${id}`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
  },
}
